import * as request from '../types/request'

export const setRequestsLoading = (value) => ({
    type: request.LOADING,
    value
})

export const reset = () => ({
    type: request.RESET
})
